import { forwardRef } from 'react';
import { Avatar, type AvatarProps } from '@mui/material';
import { designTokens } from '../tokens';

export type IdentityAvatarSize = 24 | 32 | 40 | 48 | 72 | 96 | 120;

export type IdentityAvatarProps = AvatarProps & {
  size?: IdentityAvatarSize;
};

const typographyBySize = {
  24: { fontSize: '0.625rem', lineHeight: '1rem', fontWeight: 400 },
  32: { fontSize: '0.75rem', lineHeight: '1rem', fontWeight: 400 },
  40: { fontSize: '1rem', lineHeight: '1.5rem', fontWeight: 400 },
  48: { fontSize: '1.125rem', lineHeight: '1.5rem', fontWeight: 400 },
  72: { fontSize: '1.75rem', lineHeight: '2.25rem', fontWeight: 700 },
  96: { fontSize: '2.5rem', lineHeight: '3rem', fontWeight: 700 },
  120: { fontSize: '3rem', lineHeight: '3.5rem', fontWeight: 700 },
} as const;

/** 사진과 대체 문자를 표시합니다. 이름·문자 계산과 편집 동작은 호출자가 소유합니다. */
export const IdentityAvatar = forwardRef<HTMLDivElement, IdentityAvatarProps>(function IdentityAvatar(
  { size = 40, sx, ...props },
  ref,
) {
  const sxOverrides = Array.isArray(sx) ? sx : sx ? [sx] : [];

  return <Avatar
    {...props}
    ref={ref}
    sx={[
      {
        width: size,
        height: size,
        flexShrink: 0,
        bgcolor: designTokens.color.accentSoft,
        color: designTokens.color.accentText,
        ...typographyBySize[size],
        '& .MuiAvatar-img': { objectFit: 'cover' },
      },
      ...sxOverrides,
    ]}
  />;
});
